module.exports = __webpack_public_path__ + "static/img/dome.28bbe8a3.png";